
import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../../common/services/cqs/IPrimaryKey";

export class CreateGrotkontraktCommand extends BasicCommand<CreateGrotkontraktCommand> {

    guid: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "CreateGrotkontraktCommand";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "CreateGrotkontrakt";

    get primaryKey(): IPrimaryKey<CreateGrotkontraktCommand> {
        return {
            kontraktGuid: this.guid
        };
    }

    constructor(kontraktGuid: string) {
        super(CreateGrotkontraktCommand.$type, CreateGrotkontraktCommand.$groupKey, CommandType.Insert);
        this.guid = kontraktGuid;
    }
}
